<template>
  <va-modal
    v-model="toOpenModal"
    :title="$t('subscriptions.typeModalTitle')"
    :hideDefaultActions="true"
    :noOutsideDismiss="true"
    :noEscDismiss="true"
  >
    <div class="row subscription-types" style="text-align: center;">
      <div class="flex xs12 md6">
        <div class="types" @click="toSubscriptionCreate('free')">
          <va-icon
            name="fa fa-check-square-o"
            size="25px"
          /> <br/>
          {{ $t('subscriptions.freeOrTips') }}
        </div>
      </div>
      <div class="flex xs12 md6">
        <div class="types" @click="toSubscriptionCreate('charge')">
          <va-icon
            name="fa fa-clock-o"
            size="25px"
          /> <br/>
          {{ $t('subscriptions.chargeByHourOrDay') }}
        </div>
      </div>
      <div class="flex xs12 md6">
        <div class="types" @click="toSubscriptionCreate('fix')">
          <va-icon
            name="fa fa-minus"
            size="25px"
          /> <br/>
          {{ $t('subscriptions.fixedPrice') }}
        </div>
      </div>
      <div class="flex xs12 md6">
        <div class="types">
          <va-icon
            name="fa fa-calendar"
            size="25px"
          /> <br/>
          {{ $t('subscriptions.monthlyOrWeekly') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="flex xs12">
        <div class="d-flex justify--center mt-3">
          <va-button color="gray" @click.prevent="disableModal()" class="my-0 ">{{ $t('subscriptions.close') }}</va-button>
        </div>
      </div>
    </div>
  </va-modal>
</template>

<script>
export default {
  name: 'SubscriptionTypeModal',
  props: {
    openModal: Boolean,
  },
  methods: {
    disableModal () {
      this.$emit('closemodal', false)
    },
    async toSubscriptionCreate (type) {
      await this.$router.push({
        name: 'create-app-subscription',
        params: { type: type },
      })
    },
  },
  computed: {
    toOpenModal () {
      if (this.openModal) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped>
  .subscription-types .types {
    padding: 10px;
    border: solid 1px #cccccc;
    border-radius: 5px;
    margin: 10px 10px 10px 10px;
    cursor: pointer;
  }

  .subscription-types .types:hover {
    background-color: rgb(189, 198, 249);
  }
</style>
